import { createPromiseAction } from '@adobe/redux-saga-promise';

import {
  GET_CARD_TYPE,
  VERIFY_UPI,
  UPDATE_TRANSACTION,
  FETCH_NB_OPTIONS,
  PROCESS_TRANSACTION,
  FETCH_PAYMENT_RESPONSE,
  ADD_MONEY,
} from './constants';

export const getCardType = createPromiseAction(GET_CARD_TYPE);

export const verifyUPI = createPromiseAction(VERIFY_UPI);

export const updateTransaction = createPromiseAction(UPDATE_TRANSACTION);

export const fetchNBOptions = createPromiseAction(FETCH_NB_OPTIONS);

export const processTransaction = createPromiseAction(PROCESS_TRANSACTION);

export const fetchPaymentResponse = createPromiseAction(FETCH_PAYMENT_RESPONSE);

export const addMoney = createPromiseAction(ADD_MONEY);
